import React, {useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import {useTranslation} from "react-i18next";
import {Alert, Button, Col, Row, Select, Table, Typography} from "antd";
import {ItemMarks} from "../../EntrantApplication/ItemMarks";
import {StyledButton} from "../../../../../pages/Entrant/AdmissionView/index.styles";
import {fetchSetExamResultAction} from "../../../../../store/pages/admission/actions";

const {Option} = Select;
const {Text} = Typography;

export const ResultExamContent = ({
                                    item,
                                    obj,
                                    handleInterviewSelect,
                                    handleExamSelect,
                                    handleSubmit,
                                    disabled,
                                    locked
                                  }:any) => {

  const dispatch = useDispatch();
  const {t} = useTranslation(["admissionView", 'executorAdmissionSteps', 'common'])

  const columns = [
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.specialty')}`,
      dataIndex: 'key',
      key: 'key',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.qualification')}`,
      dataIndex: 'qualification',
      key: 'qualification',
      width: "30%"
    },
    {
      title:`${t('executorAdmissionSteps:stepOne.specialtyForm.college')}`,
      dataIndex: 'college',
      key: 'college',
      width: "30%"
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.language')}`,
      dataIndex: 'language_of_education',
      key: 'language_of_education',
      width: "30%",
      render: (text:any) => {
        return(
          <div>
            {t(`${text}`)}
          </div>
        )
      }
    },
    {
      title: `${t('executorAdmissionSteps:stepOne.specialtyForm.priority')}`,
      dataIndex: 'priority',
      key: 'priority',
      width: "10%",
      render: (text:any) => {
        return (
          <span className="admission__border-item">
            {text}
          </span>
        )
      }
    },
  ];

  const dataSource = [
    {
      key: item.speciality.code + ' - ' + item.speciality.caption,
      qualification: item.qualification.code + ' - ' + item.qualification.caption,
      college: item.college.name,
      priority: item.priority,
      language_of_education: item.language_of_education == 1 ? t("common:kz") : item.language_of_education == 2 ? t("common.ru") : item.language_of_education == 3 ? "Английский" : "Неверный язык заявления",
    }
  ]

  const [visibleButton, setVisibleButton] = useState(false)

  const [checkDisabled, setCheckDisabled] = useState(false)

  const [disableByStatus, setDisableByStatus] = useState(false)

  const [disableIfEmpty, setDisableIfEmpty] = useState(false)


  useEffect(() => {
    setDisableByStatus(item.status === null || item.status === "20" || item.status === "29")
  }, [item])


  useEffect(() => {
    setVisibleButton(item.examTypes.length === 0 || item.examTypes.some((exam:any) => exam.is_avail_status === true))
  }, [item])


  useEffect(() => {
    let checkObj = obj && obj.some((res:any) => item.id === res.id && (res.rating === "2" || res.interview_result === 2 || res.psychometric_result === 2))
    let checkExamTypes = item.examTypes.some((exam:any) => exam.result === "2")
    let markCondition = obj.some((obj:any) => obj.rating === '2')

    setCheckDisabled(obj.length ? (markCondition ? markCondition : checkObj) : checkExamTypes)
  }, [obj, item])


  useEffect(() => {
    let statusArr = item.examTypes.filter((exam:any) => exam.is_avail_status === true && (exam.field_for_update_result === "interview_result" || exam.field_for_update_result === "psychometric_result"))
    let checkObj = obj && obj.filter((res:any) => res.id === item.id)
    let checkItem = item.examTypes.filter((exam:any) => exam.result !== null)
    let check = obj ? !(checkObj.length === statusArr.length) : !(checkItem.length === statusArr.length)

    setDisableIfEmpty(check)
  }, [obj, item])

  const handleResultExamAction = (status:any) => {

    switch (status) {
      case "20":
        return `${t('admissionView:stepsTitle.stepThree.caption.notSent')}`
      case "21":
      case "22":
      case "23":
      case "24":
      case "26":
      case "27":
      case "28":
      case "30":
      case "31":
        return `${t('admissionView:stepsTitle.stepThree.caption.sent')}`
      case "29":
      case "32":
        return `${t('admissionView:stepsTitle.stepThree.caption.notSent')}`
      default:
        return `${t('admissionView:stepsTitle.stepThree.caption.notAdmitted')}`
    }

  }

  const handleResultExamColorAction = (status:any) => {

    switch (status) {
      case "20":
      case "29":
      case "32":
        return "warning"
      case "21":
      case "22":
      case "23":
      case "24":
      case "26":
      case "27":
      case "28":
      case "30":
      case "31":
        return "info"
      default:
        return "error"
    }

  }


  return (
    <div className="result">
      <Table
        dataSource={dataSource}
        columns={columns}
        className={"admission__table admission__table--" + item.statusValidate}
        bordered={true}
        pagination={false}
        rowKey={(record) => `${record.key}-${record.priority}`}
      />

      <Row
        className="result__content"
      >
        <Col span={24} style={{padding: 20}}>

          <Row
            className="result__item"
            justify="space-between"
          >
            <Col
              className="result__columns"
              flex="0 0 50%"
            >
              <Text>{t('admissionView:stepsTitle.stepThree.caption.average')}: {item.marksStep3.average}</Text>
            </Col>

            <Col
              className="result__columns"
              flex="0 0 50%"
            >
              <Alert
                // item.status === null || item.status === "20" ? `${t('admissionView:stepsTitle.stepThree.caption.notSent')}` : item.status === "22" ? `${t('admissionView:stepsTitle.stepThree.caption.sent')}` : item.status === "29" ? `${t('admissionView:stepsTitle.stepThree.caption.notSent')}` : item.status === "32" ? `${t('admissionView:stepsTitle.stepThree.caption.notSent')}` : `${t('admissionView:stepsTitle.stepThree.caption.notAdmitted')}`
                message={handleResultExamAction(item.status)}
                type={handleResultExamColorAction(item.status)}/>
            </Col>

          </Row>

          <Row
            className="result__item"
            justify="space-between"
          >

            {item.marksStep3 && item.marksStep3.requiredMarks && item.marksStep3.requiredMarks.length > 0 &&
                <Col span={11} key={item.id + "-requiredMarks"}>
                    <ItemMarks
                        headerTitle={t('stepsTitle.stepTwo.title.required')}
                        footerVisible={false}
                        selectedSpecialityId={item.id}
                        data={item.marksStep3.requiredMarks}
                        disabledInput={true}
                        span={24}
                        headerColor={item.statusValidate}
                    />
                </Col>
            }

            {item.marksStep3.profileMarks.length > 0 &&
                <Col span={12} key={item.id + "-profileMarks"}>
                    <ItemMarks
                        headerTitle={t('stepsTitle.stepTwo.title.profile')}
                        footerVisible={false}
                        selectedSpecialityId={item.id}
                        data={item.marksStep3.profileMarks}
                        disabledInput={true}
                        span={24}
                        headerColor={item.statusValidate}
                    />
                </Col>
            }

          </Row>

          <Row gutter={24} align="bottom">

            <Col span={16}>
              {item.examTypes.map((res:any, index:any) => {
                if (res.is_avail_status === true) {
                  if (res.label === "Собеседование") {
                    return <Row
                      className="result__item"
                      key={res.label + `-${index}`}
                      align='middle'
                    >
                      <Col
                        className="result__columns"
                        span={12}
                      >
                        <Text>{res.label}</Text>
                      </Col>

                      <Col
                        className="result__columns"
                        span={12}
                      >
                        <Select
                          className="admission__select"
                          onChange={(value) => handleInterviewSelect(res.id, value, "interview_result")}
                          defaultValue={item.status === null || item.status === "20" || item.status === "29" ? null : item.status === "22" ? 1 : 2}
                          disabled={!disableByStatus || disabled || item.statusValidate === "gray"}
                        >
                          <Option value={1}>{t('admissionView:stepsTitle.stepThree.caption.admission')}</Option>
                          <Option value={2}>{t('admissionView:stepsTitle.stepThree.caption.nonAdmission')}</Option>
                        </Select>
                      </Col>
                    </Row>
                  } else if (res.label === "Психометрическое тестирование") {
                    return <Row
                      className="result__item"
                      key={res.label}
                      align='middle'
                    >
                      <Col
                        className="result__columns"
                        span={12}
                      >
                        <Text>{res.label}</Text>
                      </Col>

                      <Col
                        className="result__columns"
                        span={12}
                      >
                        <Select
                          className="admission__select"
                          onChange={(value) => handleInterviewSelect(res.id, value, "psychometric_result")}
                          defaultValue={item.status === null || item.status === "20" || item.status === "29" ? null : item.status === "22" ? 1 : 2}
                          disabled={!disableByStatus || disabled || item.statusValidate === "gray"}
                        >
                          <Option value={1}>{t('admissionView:stepsTitle.stepThree.caption.admission')}</Option>
                          <Option value={2}>{t('admissionView:stepsTitle.stepThree.caption.nonAdmission')}</Option>
                        </Select>
                      </Col>
                    </Row>
                  } else if (res.label === "Экзамен") {
                    return <Row
                      className="result__item"
                      key={res.label}
                      align='middle'
                    >
                      <Col span={24} style={{marginBottom: 20}}>
                        {t('admissionView:stepsTitle.stepThree.caption.exam')}
                      </Col>
                      {item.marksStep3.examMarks.map((mark:any, index:any) => (
                        <Col span={12} key={mark.id + `-${index}`}>
                          <Row className="marks__item">
                            <Col flex="46px">
                              <Select
                                suffixIcon={null}
                                defaultValue={mark.rating}
                                className="marks__input"
                                onChange={(value) => handleExamSelect(mark, value, item.id)}
                                disabled={!disableByStatus || disabled || item.statusValidate === "gray"}
                              >
                                <Option value="2">2</Option>
                                <Option value="3">3</Option>
                                <Option value="4">4</Option>
                                <Option value="5">5</Option>
                                <Option value={null}>Н</Option>
                              </Select>

                            </Col>

                            <Col>
                              <Text>{mark.subject_name}</Text>
                            </Col>

                          </Row>
                        </Col>
                      ))}
                    </Row>
                  }
                }
              })}
            </Col>

            {visibleButton && !disabled && item.statusValidate !== "gray" &&
                <Col span={8}>
                  {/*{(item.base_education === "2") && (*/}
                  {/*  <Col className="result__columns">*/}
                  {/*    {checkDisabled && item.status !== "33" ?*/}
                  {/*      <StyledButton*/}
                  {/*        loading={item.loading}*/}
                  {/*        type="primary"*/}
                  {/*        style={{float: "right", height: 40}}*/}
                  {/*        onClick={() => handleSubmit(item.id, 33)}*/}
                  {/*        disabled={locked}*/}
                  {/*      >*/}
                  {/*        {t('admissionView:stepsButton.save')}*/}
                  {/*      </StyledButton>*/}

                  {/*      :*/}
                  {/*      item.status === "22" ?*/}
                  {/*        item?.raging?.status != 1 ?*/}
                  {/*          (*/}
                  {/*            <Button*/}
                  {/*              loading={item.loading}*/}
                  {/*              style={{borderRadius: 4, float: "right"}}*/}
                  {/*              type="primary"*/}
                  {/*              onClick={() => handleSubmit(item.id, 29)}*/}
                  {/*              disabled={item.status == "22" ? false : locked}*/}
                  {/*            >*/}
                  {/*              {t('admissionView:stepsButton.return')}*/}
                  {/*            </Button>*/}
                  {/*          ) : null*/}
                  {/*        : (item.status === "20" || item.status === "29") ? (*/}
                  {/*          <StyledButton*/}
                  {/*            loading={item.loading}*/}
                  {/*            type="primary"*/}
                  {/*            style={{float: "right", height: 40}}*/}
                  {/*            onClick={() => handleSubmit(item.id, 22)}*/}
                  {/*            disabled={disableIfEmpty}*/}
                  {/*          >*/}
                  {/*            {t('admissionView:stepsButton.send')}*/}
                  {/*          </StyledButton>*/}
                  {/*        ) : item.status === null ?*/}
                  {/*          <StyledButton*/}
                  {/*            loading={item.loading}*/}
                  {/*            type="primary"*/}
                  {/*            style={{float: "right", height: 40}}*/}
                  {/*            onClick={() => handleSubmit(item.id, 22)}*/}
                  {/*            disabled={disableIfEmpty || locked}*/}
                  {/*          >*/}
                  {/*            {t('admissionView:stepsButton.send')}*/}
                  {/*          </StyledButton>*/}
                  {/*          : item.status === "29" ?*/}
                  {/*            <StyledButton*/}
                  {/*              type="primary"*/}
                  {/*              style={{float: "right", height: 40}}*/}
                  {/*              onClick={() => handleSubmit(item.id, 22)}*/}
                  {/*              disabled={disableIfEmpty || locked}*/}
                  {/*              loading={item.loading}*/}
                  {/*            >*/}
                  {/*              {t('admissionView:stepsButton.send')}*/}
                  {/*            </StyledButton>*/}
                  {/*            : ""*/}
                  {/*    }*/}
                  {/*  </Col>*/}
                  {/*)}*/}
                </Col>
            }

            {item.statusValidate !== "gray" && !visibleButton &&
                <Col span={8}>
                    <Col className="result__columns">
                      {item.status === "20" || item.status === null ?
                        <StyledButton
                          loading={item.loading}
                          type="primary"
                          style={{float: "right"}}
                          //@ts-ignore
                          onClick={() => dispatch(fetchSetExamResultAction({id: item.id, status: 22}))}
                        >
                          {t('admissionView:stepsButton.send')}
                        </StyledButton>
                        :
                        item.status === "22" ?
                          <Button
                            loading={item.loading}
                            style={{borderRadius: 4, float: "right"}}
                            type="primary"
                            onClick={() => handleSubmit(item.id, 29)}
                            disabled={false}
                          >
                            {t('admissionView:stepsButton.return')}
                          </Button> :
                          item.status === "29" ?
                            <StyledButton
                              loading={item.loading}
                              style={{borderRadius: 4, float: "right"}}
                              type="primary"
                              onClick={() => handleSubmit(item.id, 22)}
                              disabled={locked}
                            >
                              {t('admissionView:stepsButton.send')}
                            </StyledButton> : ""
                      }
                    </Col>
                </Col>
            }

          </Row>
        </Col>
      </Row>
    </div>
  )
}